import { createEmbedMessageHandler } from './embedMessageHandler';
const getOrderData = async (options, timeout = 10000) => {
    // Support legacy string parameter or new options object
    const opts = typeof options === 'string'
        ? { orderNumber: options }
        : (options || {});
    // console.log('[getOrderData] Fetching orders data:', opts);
    const response = await createEmbedMessageHandler({
        type: 'commerce.getOrders',
        payload: opts,
        timeout,
    });
    return response?.data;
};
export default getOrderData;
//# sourceMappingURL=getOrderData.js.map